import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  height: 24px;
  margin-top: auto;
`;

export const Input = styled.input.attrs({
  spellcheck: false,
})<{ isLarge?: boolean; isExpanded?: boolean; isReadOnly?: boolean; isRightAligned?: boolean }>`
  border-radius: ${({ theme }) => theme.borderRadiusDefault}px;
  width: ${({ width }) => width || '30px'};
  padding: ${({ isLarge }) => (isLarge ? '5px' : '4px')} 0;
  border: 1px solid ${({ isExpanded, theme }) => (isExpanded ? theme.borderColorInputFocus : theme.borderColorInput)};
  color: ${({ theme }) => theme.colors.gray['090']};
  background: ${({ theme, isReadOnly }) => (isReadOnly ? 'none' : theme.backgroundInput)};
  line-height: 1;
  text-align: center;
  transition:
    border-color 300ms ease,
    width 300ms ease,
    margin 300ms ease;
  font-size: ${({ theme }) => theme.fontSizeSmall}rem;
  outline: none;

  &:hover {
    border: 1px solid ${({ isReadOnly, theme }) => (isReadOnly ? 'transparent' : theme.borderColorInputHover)};
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.borderColorInputFocus};
  }

  &[type='number']::-webkit-inner-spin-button,
  &[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ${({ isReadOnly }) =>
    isReadOnly &&
    `
		border-color: transparent;
		cursor: default;
	`};

  ${({ isExpanded }) =>
    isExpanded &&
    `
		width: 105px;
	`}

  ${({ isExpanded, theme }) =>
    isExpanded &&
    `
		background: ${theme.colors.gray['010']};
		z-index: 3;
		position: relative;

		&:hover {
			border: 1px solid ${theme.colors.gray['080']};
		}
	`};

  ${({ isExpanded, isRightAligned }) =>
    isExpanded &&
    !isRightAligned &&
    `
		margin-right:  -75px;
	`};

  ${({ isExpanded, isRightAligned }) =>
    isExpanded &&
    isRightAligned &&
    `
		margin-left: -75px;
	`};
`;
